<template>
  <div class="app-breadcrumb-model">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <template v-for="(item,$index) in breadcrumbList" >
         <el-breadcrumb-item  v-if="showBreadcurmb(item)" :key="$index" >{{item}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { appInfos } from '@/module/singleSpa/appInfos'

  export default {
    name: 'breadcrumb',
    data () {
      return {
        breadcrumbList: []
      }
    },
    props: {},
    methods: {
      handlerBreadcrumbList (curPath) {
        _.map(appInfos, v => {
          curPath = _.replace(curPath, `${v.href}/`, '/')
        })
        this.breadcrumbList = _.isEmpty(global.urlKeyMap[curPath]) ? [] : global.urlKeyMap[curPath]
      },
      showBreadcurmb (item) {
        let menus = ['删除', '导出', '授权']
        if (menus.includes(item)) {
          return false
        }
        return true
      }
    },
    watch: {
      $route (to) {
        this.handlerBreadcrumbList(to.path)
      }
    },
    beforeCreate () {
    },
    created () {
      const curPath = this.$router.history.pending && this.$router.history.pending.fullPath || this.$router.history.current.fullPath // eslint-disable-line
      this.handlerBreadcrumbList(curPath)
    },
    beforeMount () {
    },
    mounted () {
    },
    beforeUpdate () {
    },
    updated () {
    },
    beforeDestroy () {
    },
    destroyed () {
    },
    computed: {
      ...mapState('common', ['resList'])
    },
    components: {}
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  .app-breadcrumb-model {
    padding: 16px 0 16px 30px;
  }
</style>



// WEBPACK FOOTER //
// src/js/module/layout/_source/breadcrumb.vue